module.exports = __webpack_public_path__ + "static/media/ms.36cc17da.png";